module.exports = "/packs/images/svg/ireland/facilities/outdoor_climbing~9cf8e6624e662237c468b05bc26779fa.svg";